(function () {
  'use strict';

  // Insulation factor by decade: older buildings need more effective heating
  // capacity per m² of stated coverage. Tunable — these are our own reasonable
  // defaults, not extracted from the old app (we had no access to its logic).
  function insulationFactor(year) {
    if (year < 1960) return 0.7;
    if (year < 1980) return 0.8;
    if (year < 2000) return 0.9;
    if (year < 2010) return 0.95;
    return 1.0;
  }

  function decadeLabel(year) {
    var decade = Math.floor(year / 10) * 10;
    return decade + '-talet';
  }

  function init(root) {
    var form = root.querySelector('[data-pump-finder-form]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('.pump-finder__step'));
    var progressBar = root.querySelector('[data-pump-finder-progress]');
    var resultsPanel = root.querySelector('[data-pump-finder-results]');
    var grid = root.querySelector('[data-pump-finder-grid]');
    var cardTemplate = root.querySelector('[data-pump-finder-card-template]');
    var dataScript = root.querySelector('[data-pump-finder-products]');
    var products = [];

    try {
      products = JSON.parse(dataScript.textContent);
    } catch (e) {
      console.error('Pump finder: could not parse product data', e);
    }

    var warrantyThreshold = parseFloat(root.dataset.warrantyThreshold || '4');
    var coldThreshold = parseFloat(root.dataset.coldThreshold || '-25');
    var cartAddUrl = root.dataset.cartAddUrl;
    var cartUrl = root.dataset.cartUrl;

    var answers = {
      area: parseFloat(form.querySelector('[data-field="area"]').value),
      year: parseFloat(form.querySelector('[data-field="year"]').value),
      highEfficiency: form.querySelector('[data-field="highEfficiency"]').checked,
      fastHeating: form.querySelector('[data-field="fastHeating"]').checked,
      efficientCooling: form.querySelector('[data-field="efficientCooling"]').checked,
      coldClimate: form.querySelector('[data-field="coldClimate"]').checked,
      longWarranty: form.querySelector('[data-field="longWarranty"]').checked,
      quickSupport: form.querySelector('[data-field="quickSupport"]').checked,
      easyMaintenance: form.querySelector('[data-field="easyMaintenance"]').checked,
      zip: ''
    };

    var currentStep = 1;
    var totalSteps = steps.length;

    function effectiveAreaNeeded() {
      return answers.area / insulationFactor(answers.year);
    }

    function matchingProducts() {
      var needed = effectiveAreaNeeded();
      // "fast heating" / "efficient cooling" are relative: among products that
      // already satisfy the area requirement, prefer the more powerful half.
      var eligibleByArea = products.filter(function (p) {
        return p.maxHeatingArea >= needed;
      });
      var heatingSorted = eligibleByArea.slice().sort(function (a, b) { return b.maxHeatingEffect - a.maxHeatingEffect; });
      var coolingSorted = eligibleByArea.slice().sort(function (a, b) { return b.maxCoolingEffect - a.maxCoolingEffect; });
      var heatingMedian = heatingSorted.length ? heatingSorted[Math.floor(heatingSorted.length / 2)].maxHeatingEffect : 0;
      var coolingMedian = coolingSorted.length ? coolingSorted[Math.floor(coolingSorted.length / 2)].maxCoolingEffect : 0;

      return eligibleByArea.filter(function (p) {
        if (answers.highEfficiency && !(p.energyClassHeating === 'A++' || p.energyClassHeating === 'A+++')) return false;
        if (answers.fastHeating && p.maxHeatingEffect < heatingMedian) return false;
        if (answers.efficientCooling && p.maxCoolingEffect < coolingMedian) return false;
        if (answers.coldClimate && p.minTempOutdoorsHeating > coldThreshold) return false;
        if (answers.longWarranty && p.productWarranty < warrantyThreshold) return false;
        if (answers.quickSupport && !p.prioritizedSupport) return false;
        if (answers.easyMaintenance && !p.hasSelfCleaning) return false;
        return true;
      }).sort(function (a, b) { return a.price - b.price; });
    }

    function updateMatchCount() {
      var count = matchingProducts().length;
      var els = root.querySelectorAll('[data-match-count]');
      for (var i = 0; i < els.length; i++) els[i].textContent = count;
    }

    function updateProgress() {
      progressBar.style.width = Math.round((currentStep / totalSteps) * 100) + '%';
    }

    function showStep(stepNumber) {
      currentStep = stepNumber;
      steps.forEach(function (step) {
        var n = parseInt(step.dataset.step, 10);
        step.hidden = n !== stepNumber;
      });
      updateProgress();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    form.addEventListener('input', function (event) {
      var field = event.target.dataset.field;
      if (!field) return;

      if (field === 'area') {
        answers.area = parseFloat(event.target.value);
        form.querySelector('[data-area-output]').textContent = answers.area + ' m²';
      } else if (field === 'year') {
        answers.year = parseFloat(event.target.value);
        form.querySelector('[data-year-output]').textContent = decadeLabel(answers.year);
      } else if (field === 'zip') {
        answers.zip = event.target.value;
        return; // doesn't affect matching, skip count update
      } else if (event.target.type === 'checkbox') {
        answers[field] = event.target.checked;
      }
      updateMatchCount();
    });

    form.querySelectorAll('.pump-finder__next').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (currentStep < totalSteps) showStep(currentStep + 1);
      });
    });
    form.querySelectorAll('.pump-finder__prev').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (currentStep > 1) showStep(currentStep - 1);
      });
    });

    var emptyState = root.querySelector('[data-pump-finder-empty]');

    function renderResults() {
      var matches = matchingProducts();
      root.querySelector('[data-results-count]').textContent = matches.length;
      grid.innerHTML = '';
      emptyState.hidden = matches.length > 0;

      matches.forEach(function (product) {
        var card = cardTemplate.content.cloneNode(true);
        var links = card.querySelectorAll('[data-card-link]');
        links.forEach(function (a) { a.href = product.url; });
        var img = card.querySelector('[data-card-image]');
        img.src = product.image;
        img.alt = product.title;
        card.querySelector('[data-card-vendor]').textContent = product.vendor;
        card.querySelectorAll('[data-card-link]')[1].textContent = product.title;
        card.querySelector('[data-card-coverage]').textContent = 'Uppvärmningsyta: upp till ' + product.maxHeatingArea + ' m²';
        card.querySelector('[data-card-price]').textContent = product.priceFormatted;

        var addBtn = card.querySelector('[data-card-add]');
        var addedMsg = card.querySelector('[data-card-added]');
        addBtn.addEventListener('click', function () {
          addBtn.disabled = true;
          addBtn.textContent = 'Lägger till…';
          fetch(cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: product.variantId,
                quantity: 1,
                properties: answers.zip ? { 'Postnummer (från guiden)': answers.zip } : undefined
              }]
            })
          })
            .then(function (res) {
              if (!res.ok) throw new Error('Cart add failed');
              return res.json();
            })
            .then(function () {
              addBtn.hidden = true;
              addedMsg.hidden = false;
              addedMsg.querySelector('[data-cart-link]').href = cartUrl;
              document.dispatchEvent(new CustomEvent('cart:updated'));
            })
            .catch(function (err) {
              console.error('Pump finder: add to cart failed', err);
              addBtn.disabled = false;
              addBtn.textContent = 'Kunde inte lägga till — försök igen';
            });
        });

        grid.appendChild(card);
      });
    }

    form.querySelector('.pump-finder__show-results').addEventListener('click', function () {
      form.hidden = true;
      progressBar.parentElement.hidden = true;
      resultsPanel.hidden = false;
      renderResults();
      resultsPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    function restart() {
      form.hidden = false;
      progressBar.parentElement.hidden = false;
      resultsPanel.hidden = true;
      showStep(1);
    }

    root.querySelector('.pump-finder__restart').addEventListener('click', restart);
    var restartInline = root.querySelector('.pump-finder__restart-inline');
    if (restartInline) restartInline.addEventListener('click', restart);

    updateMatchCount();
    updateProgress();
  }

  document.querySelectorAll('[data-pump-finder]').forEach(init);
})();
